
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.11","height":"20.515"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 8214","fill":"#28345c"}},[_c('path',{attrs:{"data-name":"Path 6225","d":"M2.501 9.781a1 1 0 01-.138-.01.994.994 0 01-.848-1.121 10.049 10.049 0 0119.341-2.181.994.994 0 11-1.857.708A8.062 8.062 0 003.484 8.924a.994.994 0 01-.983.857z"}}),_c('path',{attrs:{"data-name":"Path 6227","d":"M20.606 10.734a.995.995 0 01.99 1.131 10.049 10.049 0 01-19.341 2.181.994.994 0 111.857-.708 8.062 8.062 0 0015.516-1.747.994.994 0 01.978-.857z"}}),_c('path',{attrs:{"data-name":"Path 6226","d":"M20.753 8.594a.99.99 0 01-.393-.032l-3.52-1.001a.994.994 0 01.544-1.912l2.564.73.701-2.457a.994.994 0 111.912.545l-.973 3.413a.994.994 0 01-.835.714z"}}),_c('path',{attrs:{"data-name":"Path 6228","d":"M2.358 11.92a.99.99 0 01.393.032l3.52 1.001a.994.994 0 01-.544 1.912l-2.564-.73-.701 2.457a.994.994 0 11-1.912-.545l.973-3.413a.994.994 0 01.835-.714z"}})])])
          )
        }
      }
    